import './infoAdd.scss';

function InfoAdd(props) {
  return (
    <div className='infoAdd'>
        <p className='infoAdd__value'> {props.value} </p>
        <p className='infoAdd__text'> {props.text} </p>
    </div>
  );
}

export default InfoAdd;